import React, { useState } from "react"
import { Checkbox, Radio,CircularProgress, FormHelperText } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import ListItemText from "@material-ui/core/ListItemText"
import { SearchIcon } from "@iconsGallery"
import ClearIcon from "@material-ui/icons/Clear"
import { Button, OutlinedInput, FormControl } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import * as QA_Automation from "@qaAutomation"
const useStyle = makeStyles({
  disableTextHover: {
    "& .MuiListItem-button:hover": {
      background: "transparent !important",
    },
  },
  formControl: {
    "& .MuiFormLabel-root.Mui-focused": {
      color: "var(--primaryColor)",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "var(--primaryColor)",
      },
    },
  },
  menuCheckbox: {
    minHeight: "28px !important",
    height: "auto",
    paddingTop: "2px !important",
    paddingBottom: "2px !important",
    whiteSpace: "normal",
    wordBreak: "break-word",
    "& .MuiCheckbox-root, & .MuiRadio-root": {
      padding: "4px !important",
    },
    "& .MuiCheckbox-colorSecondary.Mui-disabled": {
      color: "gray !important",
    },
    "& .MuiListItemText-root": {
      marginTop: "0 !important",
      marginBottom: "0 !important",
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "anywhere",
    },
  },
  textInput: {
    width: "100%",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primaryColor)",
    },
  },
	scrollContainer: {
		minHeight: "120px",
		maxHeight: "240px",
		overflowY: "auto",
		"&::-webkit-scrollbar": {
			width: "4px",

		},
		"&::-webkit-scrollbar-track": {
			background: "pink",
		},
		"&::-webkit-scrollbar-thumb": {
			background: "var(--primaryColor)",
			borderRadius: "4px",
		},
		"&::-webkit-scrollbar-thumb:hover": {
			background: "var(--primaryColor)",
			filter: "brightness(0.9)",
		},
		scrollbarWidth: "thin",
	},
})

const isEmptyValue = (val) => {
	if (val === undefined || val === null || val === "") return true
	if (Array.isArray(val) && val.length === 0) return true
	if (typeof val === "object" && Object.keys(val).length === 0) return true
	return false
}

const getItemDisplayName = (item) => {
	if (item === null || item === undefined) return ""
	if (typeof item !== "object") return String(item)
	if (item.locationName !== undefined) return item.locationName
	if (item.name !== undefined) return item.name
	if (item.label !== undefined) return item.label
	if (item.storeName !== undefined) return item.storeName
	if (item.store_name !== undefined) return item.store_name
	if (item.categoryName !== undefined) return item.categoryName
	if (item.category_name !== undefined) return item.category_name
	if (item.id !== undefined) return String(item.id)
	if (item._id !== undefined) return String(item._id)
	return String(item)
}

const getItemVal = (item, valIdent, isPlain) => {
	if (isPlain) return item
	if (item === null || item === undefined) return item
	if (typeof item !== "object") return item
	if (valIdent && valIdent !== "name" && item[valIdent] !== undefined) return item[valIdent]
	if (item.id !== undefined) return item.id
	if (item._id !== undefined) return item._id
	if (item.value !== undefined) return item.value
	if (item.store_id !== undefined) return item.store_id
	if (item.locationId !== undefined) return item.locationId
	if (valIdent && item[valIdent] !== undefined) return item[valIdent]
	if (item.name !== undefined) return item.name
	if (item.locationName !== undefined) return item.locationName
	return item
}

const isItemSelected = (item, selectedList, valIdent, isPlain) => {
	if (isEmptyValue(selectedList)) return false
	if (item === null || item === undefined) return false

	const list = Array.isArray(selectedList) ? selectedList : [selectedList]

	return list.some((i) => {
		if (i === null || i === undefined || i === "") return false
		if (i === item) return true

		const iVal = typeof i === "object" ? getItemVal(i, valIdent, false) : i
		const itemVal = typeof item === "object" ? getItemVal(item, valIdent, false) : item

		if (iVal !== undefined && itemVal !== undefined && iVal !== null && itemVal !== null) {
			if (iVal === itemVal || String(iVal) === String(itemVal)) return true
		}

		if (typeof i === "object" && typeof item === "object") {
			if (i._id !== undefined && item._id !== undefined && String(i._id) === String(item._id)) return true
			if (i.id !== undefined && item.id !== undefined && String(i.id) === String(item.id)) return true
			if (valIdent && i[valIdent] !== undefined && item[valIdent] !== undefined && String(i[valIdent]) === String(item[valIdent])) return true
			if (i.name !== undefined && item.name !== undefined && String(i.name) === String(item.name)) return true
		}

		return false
	})
}

const selectedItemsNameCache = {}

const cacheDropdownItemNames = (data, valIdent) => {
	if (data && Array.isArray(data)) {
		data.forEach((item) => {
			if (item && typeof item === "object") {
				const val = getItemVal(item, valIdent, false)
				const name = getItemDisplayName(item)
				if (val !== undefined && val !== null && name) {
					selectedItemsNameCache[String(val)] = name
				}
				if (item.id !== undefined && name) {
					selectedItemsNameCache[String(item.id)] = name
				}
				if (item._id !== undefined && name) {
					selectedItemsNameCache[String(item._id)] = name
				}
			}
		})
	}
}

const getDisplayNameForSelectedValue = (selectedVal, data, valIdent) => {
	if (isEmptyValue(selectedVal)) return ""
	if (typeof selectedVal === "object") return getItemDisplayName(selectedVal)
	if (data && Array.isArray(data)) {
		const found = data.find((d) => isItemSelected(d, selectedVal, valIdent, false) || isItemSelected(d, selectedVal, valIdent, true))
		if (found) {
			const name = getItemDisplayName(found)
			if (name) {
				const val = getItemVal(found, valIdent, false)
				selectedItemsNameCache[String(val)] = name
				selectedItemsNameCache[String(selectedVal)] = name
				return name
			}
		}
	}
	if (selectedItemsNameCache[String(selectedVal)]) {
		return selectedItemsNameCache[String(selectedVal)]
	}
	return String(selectedVal)
}

function AutocompleteDropdown(props) {
  const {
    label = "",
    fetchData = () => "",
    data: dropdownData,
    filteredItems = [],
    handleDropdownChange = () => "",
    handleSearchTerm = () => {},
    totalDocs = "",
    handleShowMore = () => {},
    searchTerm = "",
    fullWidth = false,
    isLookup = true,
    placeholder = "",
    valueIdentifier = "name",
    error,
    helperText,
    isShowFooter = true,
    isShowSearch = true,
    selectionLimit = 0,
    disableMenuName = "",
    isPlainObj = false,
    showDropdownItems = 2,//minimum number of items to show in dropdown
    checkbox = true,
	  selectAll = false,
  } = props || {}

  const isSingleSelect = selectionLimit === 1
  const classes = useStyle()
  const [loading, setLoading] = React.useState(false)
  const [open, setOpen] = useState(false)
  const [selectedItems, setSelectedItems] = React.useState(
	  isSingleSelect
		  ? (isEmptyValue(filteredItems) ? "" : (filteredItems ?? ""))
		  : (isEmptyValue(filteredItems) ? [] : (filteredItems ?? []))
  )
  const [searchText, setSearchText] = React.useState(searchTerm)
  const [selectedObj, setSelectedObj] = React.useState([])

  let ref = React.useRef()
	const isExplicitSelectAllRef = React.useRef(false)
	const searchTimeoutRef = React.useRef(null)
	const prevDropdownDataRef = React.useRef([])

  const { t } = useTranslation()

	const selectedItemsRef = React.useRef(selectedItems)
	React.useEffect(() => {
		selectedItemsRef.current = selectedItems
	})

	React.useEffect(() => {
		cacheDropdownItemNames(dropdownData, valueIdentifier)
		if (selectAll && !isSingleSelect && dropdownData && dropdownData.length > 0) {
			const currentSelected = selectedItemsRef.current || []
			const wasAllSelected = isExplicitSelectAllRef.current

			if (wasAllSelected) {
				const toAdd = isPlainObj
					? dropdownData.filter((item) => !isItemSelected(item, currentSelected, valueIdentifier, true))
					: dropdownData
						.map((item) => getItemVal(item, valueIdentifier, false))
						.filter((val) => !isItemSelected(val, currentSelected, valueIdentifier, false))

				if (toAdd.length > 0) {
					const newSelected = [...(Array.isArray(currentSelected) ? currentSelected : [currentSelected]), ...toAdd]
					setSelectedItems(newSelected)
					if (isPlainObj) {
						handleDropdownChange(newSelected, label, "isPlainObj", "select-all")
					} else {
						handleDropdownChange(newSelected, label, "", "select-all")
					}
				}
			}
		}
		const newPrev = dropdownData ? [...dropdownData] : []
		prevDropdownDataRef.current = newPrev
	}, [dropdownData, selectAll, isSingleSelect, isPlainObj, valueIdentifier, label, handleDropdownChange])

	React.useEffect(() => {
		setLoading(false)
		if (searchTimeoutRef.current) {
			clearTimeout(searchTimeoutRef.current)
		}
	}, [dropdownData])

  React.useEffect(() => {
    setSearchText(searchTerm || "")
  }, [searchTerm])

  React.useEffect(() => {
	if (isSingleSelect) {
		if (isEmptyValue(filteredItems)) {
			setSelectedItems("")
		} else {
			setSelectedItems(filteredItems ?? "")
		}
	} else {
		if (isEmptyValue(filteredItems)) {
			setSelectedItems([])
		} else {
			setSelectedItems(filteredItems ?? [])
		}
	}
  }, [filteredItems, isSingleSelect])

	React.useEffect(() => {
		const handleClickOutside = (event) => {
			const isInsideSelect = ref.current && ref.current.contains(event.target)
			const isInsideMenu = event.target && (
				event.target.closest?.(".cls-detailedTransactionReport-common-type") ||
				event.target.closest?.(".MuiMenu-paper")
			)
			if (!isInsideSelect && !isInsideMenu) {
				setOpen(false)
			}
		}
		document.addEventListener("mousedown", handleClickOutside)
		return () => {
			document.removeEventListener("mousedown", handleClickOutside)
		}
	}, [])

	const isItemSelectedLocal = (item) => {
		return isItemSelected(item, selectedItems, valueIdentifier, isPlainObj)
	}

  React.useEffect(() => {
    console.log(">>>>>> trigger")
    QA_Automation?.doAddOnTestIdCommonAutoCompleteDropdown(ref, props)
  }, [selectedItems, searchTerm, filteredItems])

  const ITEM_HEIGHT = 70
  const ITEM_PADDING_TOP = 5
  const MenuProps = {
    style: { zIndex: 1300 },
    PaperProps: {
      style: {
        maxHeight: "none",
        width: 250,
        zIndex: 1300,
      },
    },
    getContentAnchorEl: () => null,
    anchorOrigin: { vertical: "bottom" },
  }

	const handleChange = (e) => {
    let value = e.target.value

    // ⭐ SINGLE SELECT MODE
    if (isSingleSelect) {
		if (value === "") return
		setSelectedItems(value)
		isExplicitSelectAllRef.current = false
		handleDropdownChange(value, label, isPlainObj ? "isPlainObj" : "")
		return
    }

    // ⭐ MULTI SELECT MODE (existing behaviour improved)
		if (Array.isArray(value)) {
			value = value.filter(val => val !== "")
		}
    if (isPlainObj) {
		const hasSelectAll = value.some(item => item && (item[valueIdentifier] === "select-all-option" || item._id === "select-all-option" || item.id === "select-all-option"))
		if (hasSelectAll) {
			if (searchText) return
			const allSelected = dropdownData.every((item) => isItemSelected(item, selectedItems, valueIdentifier, true))

			let newSelected
			if (allSelected) {
				newSelected = []
				isExplicitSelectAllRef.current = false
			} else {
				const toAdd = dropdownData.filter((item) => !isItemSelected(item, selectedItems, valueIdentifier, true))
				newSelected = [...(selectedItems || []), ...toAdd]
				isExplicitSelectAllRef.current = true
			}

			setSelectedItems(newSelected)
			handleDropdownChange(newSelected, label, "isPlainObj", allSelected ? "deselect-all" : "select-all")
			return
		}

		if (selectionLimit > 0 && value.length > selectionLimit) return
		setSelectedItems(value)
		isExplicitSelectAllRef.current = false
		handleDropdownChange(value, label, "isPlainObj")
    } else {
		const hasSelectAll = value.includes("select-all-option")
		if (hasSelectAll) {
			if (searchText) return
			const allSelected = dropdownData.every((item) => isItemSelected(item, selectedItems, valueIdentifier, false))

			let newSelected
			if (allSelected) {
				newSelected = []
				isExplicitSelectAllRef.current = false
			} else {
				const toAdd = dropdownData
					.map((item) => getItemVal(item, valueIdentifier, false))
					.filter((val) => !isItemSelected(val, selectedItems, valueIdentifier, false))
				newSelected = [...(selectedItems || []), ...toAdd]
				isExplicitSelectAllRef.current = true
			}

			setSelectedItems(newSelected)
			handleDropdownChange(newSelected, label, "", allSelected ? "deselect-all" : "select-all")
			return
		}

		if (selectionLimit > 0 && value.length > selectionLimit) return
		setSelectedItems(value)
		isExplicitSelectAllRef.current = false
		handleDropdownChange(value, label)
    }
	}

	let isAllSelected = false
	let isSomeSelected = false

	if (selectAll && !isSingleSelect && dropdownData && dropdownData.length > 0) {
		const selectedInDropdown = dropdownData.filter((item) => isItemSelected(item, selectedItems, valueIdentifier, isPlainObj))
		isAllSelected = isExplicitSelectAllRef.current || selectedInDropdown.length === dropdownData.length
		isSomeSelected = selectedInDropdown.length > 0
	}

  const handleSearch = (val) => {
    setLoading(true)
    setSearchText(val)
	  if (searchTimeoutRef.current) {
		  clearTimeout(searchTimeoutRef.current)
	  }
	  searchTimeoutRef.current = setTimeout(() => {
      setLoading(false)
	  }, 3000)
    handleSearchTerm(val, label)
  }

//   let selectedId = []
//   selectedItems?.map((x) => selectedId?.push(x.id))
  return (
    <FormControl className={classes.formControl} fullWidth={fullWidth}>
      <Select
        multiple={!isSingleSelect}
        value={selectedItems ?? (isSingleSelect ? "" : [])}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={(event) => {
          handleChange(event)
        }}
        defaultValue="none"
        placeholder={t(placeholder)}
        displayEmpty
        input={
          <OutlinedInput
            margin="dense"
            style={{ width: "30vh", height: "36px" }}
          />
        }
        // renderValue={(selected) => {
        //   if (isPlainObj) {
        //     if (selected?.length > 0) {
        //       const remaining = selected?.length - showDropdownItems
        //       return (
        //         <b>
        //           {selected
        //             .slice(0, showDropdownItems)
        //             .map((item) => item.name)
        //             .join(", ")}{" "}
        //           {selected?.length > showDropdownItems &&
        //             `${t("AND")} ${remaining} ${t("MORE")}`}
        //         </b>
        //       )
        //     } else {
        //       return <b>{t(label)}</b>
        //     }
        //   } else {
        //     if (selected.length > 0) {
        //       const remaining = selected.length - showDropdownItems
        //       return (
        //         <b>
        //           {selected.slice(0, 2).join(", ")}{" "}
        //           {selected?.length > showDropdownItems &&
        //             `${t("AND")} ${remaining} ${t("MORE")}`}
        //         </b>
        //       )
        //     } else {
        //       return <b>{t(label)}</b>
        //     }
        //   }
        // }}
        renderValue={(selected) => {
        // ⭐ SINGLE SELECT
        if (isSingleSelect) {
			if (isEmptyValue(selected)) return <b>{t(label)}</b>
            return <b>{getDisplayNameForSelectedValue(selected, dropdownData, valueIdentifier)}</b>
        }

			if (selectAll && isAllSelected) {
				return <b>{t("ALL")}</b>
			}

        // ⭐ MULTI SELECT (existing)
        if (isPlainObj) {
			if (selected && selected.length > 0) {
            const selectedNames = (Array.isArray(selected) ? selected : [selected]).map(i => getItemDisplayName(i))
            const remaining = selectedNames.length - showDropdownItems
            return (
                <b>
                {selectedNames.slice(0, showDropdownItems).join(", ")}
                {selectedNames.length > showDropdownItems &&
                    ` ${t("AND")} ${remaining} ${t("MORE")}`}
                </b>
            )
            }
            return <b>{t(label)}</b>
        }

			if (selected && selected.length > 0) {
            const selectedNames = (Array.isArray(selected) ? selected : [selected]).map(v => getDisplayNameForSelectedValue(v, dropdownData, valueIdentifier))
            const remaining = selectedNames.length - showDropdownItems
            return (
            <b>
                {selectedNames.slice(0, showDropdownItems).join(", ")}
                {selectedNames.length > showDropdownItems &&
                ` ${t("AND")} ${remaining} ${t("MORE")}`}
            </b>
            )
        }

        return <b>{t(label)}</b>
        }}
        style={{
          backgroundColor: "transparent",
          height: "38px",
          width: fullWidth ? "100%" : isLookup ? "20vh" : "255px",
        }}
        id="id-detailedTransactionReport-common"
        labelId="id-detailedTransactionReport-common"
        MenuProps={{
          ...MenuProps,
          style: { zIndex: 1300, ...MenuProps?.style },
          PaperProps: {
            ...MenuProps?.PaperProps,
            style: {
              ...MenuProps?.PaperProps?.style,
              zIndex: 1300,
            },
          },
          classes: { paper: "cls-detailedTransactionReport-common-type" },
          MenuListProps: {
            style: {
              padding: 0,
            },
          },
        }}
        ref={ref}
      >
			  {isShowSearch && (
				  <MenuItem
					  value=""
					  onKeyDown={(e) => e.stopPropagation()}
					  onClick={(e) => {
						  e.preventDefault()
						  e.stopPropagation()
					  }}
					  onMouseDown={(e) => {
						  e.stopPropagation()
					  }}
					  style={{
						  padding: "5px 10px 10px 10px",
						  backgroundColor: "#ffffff",
						  borderBottom: "1px solid #e0e0e0",
					  }}
				  >
					  <TextField
						  variant="outlined"
						  size="small"
						  placeholder={t("SEARCH")}
						  value={searchText}
						  onClick={(e) => {
							  e.stopPropagation()
						  }}
						  onMouseDown={(e) => {
							  e.stopPropagation()
						  }}
						  onKeyDown={(e) => {
							  e.stopPropagation()
						  }}
						  InputProps={{
							  endAdornment: (
								  <React.Fragment>
									  {searchText ? (
										  <ClearIcon
											  style={{ color: "#888", cursor: "pointer", fontSize: "18px" }}
											  onMouseDown={(e) => {
												  e.preventDefault()
												  e.stopPropagation()
											  }}
											  onClick={(e) => {
												  e.preventDefault()
												  e.stopPropagation()
												  handleSearch("")
											  }}
										  />
									  ) : (
										  <SearchIcon style={{ color: "#CCC" }} />
									  )}
								  </React.Fragment>
							  ),
						  }}
						  className={classes.textInput}
						  onChange={(event) => {
							  handleSearch(event.target.value.replace(/(\s{2,})/g, " "))
						  }}
					  />
				  </MenuItem>
			  )}
			  {selectAll && !isSingleSelect && !searchText && !searchTerm && dropdownData && dropdownData.length > 0 && (
				  <MenuItem
					  key="select-all-menu-item"
					  value={isPlainObj ? { [valueIdentifier]: "select-all-option", name: "Select All" } : "select-all-option"}
					  onClick={(e) => {
						  e.preventDefault()
						  e.stopPropagation()
						  const allSelected = dropdownData.every((item) => isItemSelected(item, selectedItems, valueIdentifier, isPlainObj))
						  let newSelected
						  if (allSelected) {
							  newSelected = []
							  isExplicitSelectAllRef.current = false
						  } else {
							  const toAdd = isPlainObj
								  ? dropdownData.filter((item) => !isItemSelected(item, selectedItems, valueIdentifier, true))
								  : dropdownData
									  .map((item) => getItemVal(item, valueIdentifier, false))
									  .filter((val) => !isItemSelected(val, selectedItems, valueIdentifier, false))
							  newSelected = [...(selectedItems || []), ...toAdd]
							  isExplicitSelectAllRef.current = true
						  }
						  setSelectedItems(newSelected)
						  handleDropdownChange(newSelected, label, isPlainObj ? "isPlainObj" : "", allSelected ? "deselect-all" : "select-all")
					  }}
					  style={{
						  minHeight: "28px",
						  height: "auto",
						  paddingTop: "2px",
						  paddingBottom: "2px",
						  borderBottom: "1px solid #e0e0e0",
						  backgroundColor: "#ffffff",
						  whiteSpace: "normal",
						  wordBreak: "break-word",
					  }}
				  >
					  <Checkbox
						  checked={isAllSelected}
						  style={{ padding: "4px", marginRight: "10px", flexShrink: 0, color: "var(--primaryColor)", pointerEvents: "none" }}
					  />
					  <ListItemText
						  primary={t("SELECT_ALL") + (totalDocs ? ` (${totalDocs})` : "")}
						  style={{ fontSize: "14px", fontWeight: "bold", whiteSpace: "normal", wordBreak: "break-word", marginTop: 0, marginBottom: 0 }}
					  />
				  </MenuItem>
			  )}
			  <div className={classes.scrollContainer}>
				  {loading && (!dropdownData || dropdownData.length === 0) ? (
					  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "120px" }}>
						  <CircularProgress size={30} style={{ color: "var(--primaryColor)" }} />
					  </div>
				  ) : dropdownData !== undefined && dropdownData?.length > 0 ? (
						  <>
							  {dropdownData.map((name, idx) => (
								  <MenuItem
									  key={name._id || name.id || (name[valueIdentifier] !== undefined ? name[valueIdentifier] : idx)}
									  value={isPlainObj ? name : getItemVal(name, valueIdentifier, false)}
									  onClick={(e) => {
										  e.preventDefault()
										  e.stopPropagation()
										  if (isSingleSelect) {
											  const valToSelect = isPlainObj ? name : getItemVal(name, valueIdentifier, false)
											  setSelectedItems(valToSelect)
											  isExplicitSelectAllRef.current = false
											  handleDropdownChange(valToSelect, label, isPlainObj ? "isPlainObj" : "")
											  setOpen(false)
											  return
										  }
										  const exists = isItemSelected(name, selectedItems, valueIdentifier, isPlainObj)
										  let newSelected
										  if (exists) {
											  newSelected = (selectedItems || []).filter(i => !isItemSelected(name, [i], valueIdentifier, isPlainObj))
										  } else {
											  const valToAdd = isPlainObj ? name : getItemVal(name, valueIdentifier, false)
											  newSelected = [...(selectedItems || []), valToAdd]
										  }
										  if (selectionLimit > 0 && newSelected.length > selectionLimit) return
										  setSelectedItems(newSelected)
										  isExplicitSelectAllRef.current = false
										  prevDropdownDataRef.wasSelectAllActiveBeforeSearch = false
										  if (isPlainObj) {
											  handleDropdownChange(newSelected, label, "isPlainObj")
										  } else {
											  handleDropdownChange(newSelected, label)
										  }
									  }}
									  style={{ minHeight: "28px", height: "auto", paddingTop: "2px", paddingBottom: "2px", whiteSpace: "normal", wordBreak: "break-word" }}
									  disabled={getItemDisplayName(name) === disableMenuName || name.name === disableMenuName}
									  className={classes.menuCheckbox}
								  >
									  {checkbox && (
										  isSingleSelect ? (
											  <Radio
												  checked={isItemSelected(name, selectedItems, valueIdentifier, isPlainObj)}
												  disabled={getItemDisplayName(name) === disableMenuName || name.name === disableMenuName}
												  style={{ padding: "4px", marginRight: "10px", flexShrink: 0, color: "var(--primaryColor)", pointerEvents: "none" }}
											  />
										  ) : (
											  <Checkbox
												  {...QA_Automation?.doAddOnTestIdCommonAutoCompleteDropdownItemCheckBox(
													  getItemDisplayName(name)
												  )}
												  checked={isItemSelected(name, selectedItems, valueIdentifier, isPlainObj)}
												  disabled={getItemDisplayName(name) === disableMenuName || name.name === disableMenuName}
												  style={{ padding: "4px", marginRight: "10px", flexShrink: 0, color: "var(--primaryColor)", pointerEvents: "none" }}
											  />
										  )
									  )}
									  <ListItemText primary={getItemDisplayName(name)} style={{ fontSize: "14px", whiteSpace: "normal", wordBreak: "break-word", overflowWrap: "anywhere", marginTop: 0, marginBottom: 0 }} />
								  </MenuItem>
							  ))}
							  {loading && (
								  <div style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
									  <CircularProgress size={24} style={{ color: "var(--primaryColor)" }} />
								  </div>
							  )}
						  </>
					  ) : (
					  <MenuItem disabled style={{ justifyContent: "center", height: "120px", alignItems: "center" }}>
						  {t("NO_ITEMS_FOUND")}
					  </MenuItem>
				  )}
			  </div>
			  {isShowFooter && (
				  <MenuItem
					  disabled
					  style={{
						  width: "100%",
						  display: "flex",
						  justifyContent: "space-between",
						  height: "38px",
						  padding: "0 16px",
						  opacity: 1,
						  borderTop: "1px solid rgb(224, 224, 224)",
					  }}
					  onKeyDown={(e) => e.stopPropagation()}
				  >
					  {totalDocs > dropdownData?.length ? (
						  <Button
							  type="button"
							  color="primary"
							  disabled={loading}
							  style={{ fontWeight: 700, pointerEvents: "auto", minWidth: "auto", padding: "4px 8px", color: "var(--primaryColor)" }}
							  onClick={(e) => {
								  e.preventDefault()
								  e.stopPropagation()
								  setLoading(true)
								  prevDropdownDataRef.wasShowMoreClicked = true
								  handleShowMore(e, label)
								  if (searchTimeoutRef.current) {
									  clearTimeout(searchTimeoutRef.current)
								  }
								  searchTimeoutRef.current = setTimeout(() => {
									  setLoading(false)
								  }, 3000)
							  }}
						  >
							  {t("SHOW_MORE")}
						  </Button>
					  ) : (
						  <div />
					  )}
					  <span style={{ color: "rgba(0, 0, 0, 0.87)", fontSize: "14px", fontWeight: "bold" }}>
						  {(dropdownData?.length || 0) + ` ${t("OF")} ` + (totalDocs !== "" && totalDocs !== null && totalDocs !== undefined ? totalDocs : (dropdownData?.length || 0))}
					  </span>
				  </MenuItem>
        )}
      </Select>
      {error && (
        <FormHelperText
          error
          style={{ marginLeft: 14, marginRight: 14, marginTop: 4 }}
        >
          {t(helperText)}
        </FormHelperText>
      )}
    </FormControl>
  )
}
export { AutocompleteDropdown }
export default AutocompleteDropdown
